import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'src/app/services/configuration/app-config.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-success-contractor',
  templateUrl: './success-contractor.component.html',
  styleUrls: ['./success-contractor.component.scss']
})
export class SuccessContractorComponent implements OnInit {
  successContent = AppConfigService.settings.workFlow.confirmation.contractor;
  constructor(
    private router: Router,
  ) { }

  navigateToComingSoon() {
    this.router.navigate(['/coming-soon']);
  }
  ngOnInit() {
  }

}
